import { render, staticRenderFns } from "./IconAura.vue?vue&type=template&id=632d2d54&scoped=true&"
import script from "./IconAura.vue?vue&type=script&lang=ts&"
export * from "./IconAura.vue?vue&type=script&lang=ts&"
import style0 from "./IconAura.vue?vue&type=style&index=0&id=632d2d54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632d2d54",
  null
  
)

export default component.exports